import { Link } from "react-router-dom";
import { LOCATIONS } from "@/data/locations";
import { useLang } from "@/i18n/LanguageContext";
import { MapPin, ArrowRight } from "lucide-react";

export default function LocationsIndex() {
  const { t } = useLang();
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">{t("locations.eyebrow")}</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold mt-1">{t("locations.title")}</h1>
        <p className="text-muted-foreground mt-2 max-w-2xl">{t("locations.sub")}</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {LOCATIONS.map((l, i) => (
          <Link key={l.slug} to={`/locations/${l.slug}`} data-testid={`location-index-${l.slug}`}
            className="group relative rounded-2xl overflow-hidden h-64 shadow-sm animate-fade-up" style={{ animationDelay: `${i * 60}ms` }}>
            <img src={l.hero} alt={`${l.city}, ${l.country}`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-secondary/90 via-secondary/30 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-5 text-white">
              <p className="flex items-center gap-1 text-xs text-white/80"><MapPin className="w-3.5 h-3.5" /> {l.country}</p>
              <h3 className="font-heading font-extrabold text-2xl mt-1">{l.city}</h3>
              <p className="text-sm text-white/80 mt-1 line-clamp-1">{l.tagline}</p>
              <span className="inline-flex items-center gap-1 text-sm font-semibold mt-3 group-hover:gap-2 transition-all">{t("locations.explore", { city: l.city })} <ArrowRight className="w-4 h-4" /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
